
    import './styles.scoped.css';
    export default {
  "custom-range": "awsui_custom-range_16zmw_uanfn_93",
  "custom-range--no-padding": "awsui_custom-range--no-padding_16zmw_uanfn_99",
  "custom-range-form-controls": "awsui_custom-range-form-controls_16zmw_uanfn_103",
  "custom-range-duration": "awsui_custom-range-duration_16zmw_uanfn_107",
  "custom-range-unit": "awsui_custom-range-unit_16zmw_uanfn_108",
  "vertical": "awsui_vertical_16zmw_uanfn_114",
  "custom-range-duration-input": "awsui_custom-range-duration-input_16zmw_uanfn_125",
  "custom-range-unit-select": "awsui_custom-range-unit-select_16zmw_uanfn_126",
  "relative-range-radio-group": "awsui_relative-range-radio-group_16zmw_uanfn_130"
};
  